import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { UserRoles } from '../../constants/roles'

export const useIsAdmin = (): boolean => {
  const sessionData = useSelector((state: any) => state.session?.sessionData)

  return useMemo(() => {
    const userRoles = sessionData?.roles || []
    return userRoles.includes(UserRoles.ADMIN)
  }, [sessionData])
}
